import { render, staticRenderFns } from "./InduksiView.vue?vue&type=template&id=67df837a&scoped=true&lang=pug&"
import script from "./InduksiView.vue?vue&type=script&lang=js&"
export * from "./InduksiView.vue?vue&type=script&lang=js&"
import style0 from "./InduksiView.vue?vue&type=style&index=0&id=67df837a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df837a",
  null
  
)

export default component.exports